import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import LaunchDashboardContent from './components/LaunchDashboardContent';
import Modal from '../../../../modules/foundation/components/Modal';
var defaultProps = {
  open: false
};
var CloverPublishModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CloverPublishModal, _React$Component);
  var _super = _createSuper(CloverPublishModal);
  function CloverPublishModal(props) {
    var _this;
    _classCallCheck(this, CloverPublishModal);
    _this = _super.call(this, props);
    _this.state = {
      currentStep: 0
    };
    _this.onBackButtonClick = _this.onBackButtonClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CloverPublishModal, [{
    key: "onBackButtonClick",
    value: function onBackButtonClick() {
      this.addOffsetToCurrentStep(-1);
    }
  }, {
    key: "addOffsetToCurrentStep",
    value: function addOffsetToCurrentStep(offset) {
      this.setState(function (_ref) {
        var currentStep = _ref.currentStep;
        return {
          currentStep: currentStep + offset
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        open = _this$props.open,
        onOpen = _this$props.onOpen,
        onClose = _this$props.onClose;
      var currentStep = this.state.currentStep;
      return /*#__PURE__*/React.createElement(Modal, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          id: "publish-now-button",
          className: "payment-publish-button",
          onClick: onOpen
        }, "Sign Up"),
        dimmer: "inverted",
        open: open,
        onOpen: onOpen,
        onClose: onClose,
        className: "modal-container payment-banner-modal"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "inside-close-icon",
        className: "inside-close-icon",
        onClick: onClose,
        icon: true
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "close"
      })), /*#__PURE__*/React.createElement(LaunchDashboardContent, {
        show: currentStep === 0
      }));
    }
  }]);
  return CloverPublishModal;
}(React.Component);
export { CloverPublishModal as default };
CloverPublishModal.defaultProps = defaultProps;